// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bqHp_","content":"styles_content__3FZDs","row":"styles_row__3bGPo","footer":"styles_footer__2regJ","phraseLength":"styles_phraseLength__2-PTc"};